var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('form-wrapper',[_c('div',{staticClass:"successImage"}),_c('header',{staticClass:"heading",attrs:{"size":"l"}},[_vm._v(" "+_vm._s(_vm.$t('header'))+" ")]),_c('div',{staticClass:"info-message",staticStyle:{"text-align":"center"}},[_vm._v(" "+_vm._s(_vm.$t('infoMessage'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }